module.exports = __webpack_public_path__ + "img/vpn_lock.efb8892e.svg";